import { Component } from '@angular/core';

@Component({
	selector: 'app-global-data-management',
	templateUrl: './global-data-management.component.html',
	standalone: false,
})
export class GlobalDataManagementComponent {}
